// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scrolltop-wrapper[data-v-7a92f63e]{position:fixed;right:30px;top:auto;bottom:50px}.hidden[data-v-7a92f63e]{opacity:0}.hidden-right[data-v-7a92f63e]{transform:translate(40px)}.hidden-left[data-v-7a92f63e]{transform:translate(-50px)}.showElement[data-v-7a92f63e]{opacity:1;transform:translate(0);transition:all .5s ease-out}", ""]);
// Exports
module.exports = exports;
